import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@atlaskit/button';
import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';

import { deleteBanner, updateDeleteBannerModalOpen } from '../store/incidentBannersSlice';
import { AppDispatch, RootState } from '../store/store';

const DeleteBannerModal: React.FC = () => {
    const { isDeleteBannerModalOpen, banners, activeBannerKey, isLoading } = useSelector(
        (state: RootState) => state.incidentBanners
    );
    const dispatch = useDispatch<AppDispatch>();

    const onDeleteClick = () => {
        const matchedBanner = banners.find(banner => banner.key === activeBannerKey);

        if (matchedBanner) {
            dispatch(deleteBanner({ key: matchedBanner.key, projectId: matchedBanner.projectId }));
        }
    };

    return (
        <ModalTransition>
            {isDeleteBannerModalOpen && (
                <Modal onClose={() => dispatch(updateDeleteBannerModalOpen(false))}>
                    <ModalHeader>
                        <ModalTitle appearance='danger'>Delete banner?</ModalTitle>
                    </ModalHeader>
                    <ModalBody>You're about to permanently delete the banner. This action cannot be undone.</ModalBody>
                    <ModalFooter>
                        <LoadingButton
                            autoFocus={false}
                            isLoading={isLoading}
                            appearance='danger'
                            onClick={onDeleteClick}
                        >
                            Delete
                        </LoadingButton>
                        <Button
                            appearance='subtle-link'
                            onClick={() => dispatch(updateDeleteBannerModalOpen(false))}
                            isDisabled={isLoading}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
        </ModalTransition>
    );
};

export default DeleteBannerModal;
